import { createContext } from 'react';

const ReferralDetailsContext = createContext();

export default ReferralDetailsContext;
